/* Ecochic · EcoConsent — permiso explícito antes de guardar datos de salud (decisión 10, Aviso C;
   CAMBIOS_TEMA_DEV_v1 §6). Dos finalidades:
   - «perfil_piel»: perfil de piel, su historial («Cómo evoluciona tu piel»), rutinas y personalización.
   - «diario»: diario de uso y productos en uso.
   Sin permiso vigente no se escribe nada de esa finalidad (cada módulo pregunta con has/ask) y EcoStore no lo copia
   al almacén del cliente (segunda barrera, eco-store.js › snapshot). Nada de datos de salud en URLs ni eventos.

   API
     EcoConsent.has(finalidad)            → true si hay permiso vigente (versión actual y 14 años o más declarados)
     EcoConsent.ask(finalidad)            → pinta el bloque 4.1 o 4.2; promesa que se resuelve al aceptar y se rechaza
                                            con «Ver mi resultado sin guardar» / «Ahora no»
     EcoConsent.grant(finalidad, {edad14:true}) → guarda en eco_consent {version, fecha, edad14, texto_sha256}
     EcoConsent.revoke(finalidad)         → borra los datos de esa finalidad y el registro, y llama a EcoStore.flush()
     EcoConsent.block(finalidad, opts)    → HTML del bloque (casillas sin marcar) para pintarlo dentro de otra caja
     EcoConsent.info()                    → capa 4.3 «Quién guarda tus datos y para qué»
   Textos: ajustes del tema › Ecochic · Consentimiento (settings.eco_consent_*, snippet eco-consent). Registro: eco_consent (en KEYS y SAVED de eco-store). */
(function () {
  'use strict';
  var VERSION = 'v1-2026-10-03', KEY = 'eco_consent';
  var DATA = {
    perfil_piel: ['eco_profile', 'eco_skin_history', 'eco_routine', 'eco_perso'],
    diario: ['eco_diary', 'eco_inuse']
  };
  var MEM = {};
  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return MEM[k] == null ? null : MEM[k]; } }
  function put(k, v) { try { if (v == null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) { if (v == null) delete MEM[k]; else MEM[k] = v; } }
  function T(k) { return window.EcoT ? EcoT(k) : k; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fire(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {} }

  function read() { try { var o = JSON.parse(get(KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; } catch (e) { return {}; } }
  function write(o) { put(KEY, Object.keys(o).length ? JSON.stringify(o) : null); }
  function valid(r) { return !!(r && r.version === VERSION && r.edad14 === true); }
  function has(f) { return !!DATA[f] && valid(read()[f]); }
  function age14() { var o = read(); return Object.keys(o).some(function (k) { return valid(o[k]); }); }

  /* texto exacto que ve la persona (orden del bloque): su huella identifica la versión (consent_texts) */
  function shownText(f, withAge) {
    var k = f === 'diario'
      ? ['consent.diario_titulo', 'consent.diario_texto', 'consent.diario_casilla', 'consent.mas_informacion'].concat(withAge ? ['consent.edad_casilla', 'consent.edad_aviso'] : [])
        .concat(['consent.diario_retirada', 'consent.diario_empezar', 'consent.ahora_no'])
      : ['consent.perfil_titulo', 'consent.perfil_texto', 'consent.perfil_casilla', 'consent.mas_informacion', 'consent.edad_casilla', 'consent.edad_aviso',
        'consent.perfil_retirada', 'quiz.sin_email_tambien_puedes_guardar_el_pe', 'quiz.guardar_mi_perfil', 'consent.ver_sin_guardar'];
    return k.map(T).join('\n');
  }
  function sha256(s) {
    try {
      if (!(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.resolve(null);
      return crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(function (b) {
        return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
      }, function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  function grant(f, o) {
    if (!DATA[f] || !o || o.edad14 !== true) return false;
    var withAge = f !== 'diario' || o.ageShown !== false;
    var rec = { version: VERSION, fecha: new Date().toISOString(), edad14: true, texto_sha256: null };
    var all = read(); all[f] = rec; write(all);
    sha256(shownText(f, withAge)).then(function (h) {
      if (!h) return; var a = read(); if (a[f] && a[f].fecha === rec.fecha) { a[f].texto_sha256 = h; write(a); }
    });
    fire('eco:consent-changed', { finalidad: f, granted: true });
    return true;
  }
  function revoke(f) {
    if (!DATA[f]) return false;
    DATA[f].forEach(function (k) { put(k, null); });
    var all = read(); delete all[f]; write(all);
    if (f === 'perfil_piel') { try { if (window.Eco && Eco.Profile && Eco.Profile.clear) Eco.Profile.clear(); } catch (e) {} }
    try { if (window.EcoStore && EcoStore.flush) EcoStore.flush(); } catch (e) {}
    fire('eco:consent-changed', { finalidad: f, granted: false });
    return true;
  }
  /* sin permiso vigente no queda nada de esa finalidad en la copia de trabajo (también lo que viniera de antes) */
  function purge() { Object.keys(DATA).forEach(function (f) { if (!has(f)) DATA[f].forEach(function (k) { if (get(k) != null) put(k, null); }); }); }

  /* ---------- pintado ---------- */
  function block(f, opts) {
    opts = opts || {}; styles();
    var ok = opts.okAttr || 'data-eco-consent-ok', ag = opts.ageAttr || 'data-eco-consent-age14';
    var d = f === 'diario', withAge = !d || !age14();
    return '<div class="eco-consent" data-eco-consent-for="' + esc(f) + '"' + (withAge ? '' : ' data-age-known') + '>' +
      '<p class="eco-consent__t"><strong>' + T(d ? 'consent.diario_titulo' : 'consent.perfil_titulo') + '</strong></p>' +
      '<p class="eco-consent__x">' + T(d ? 'consent.diario_texto' : 'consent.perfil_texto') + '</p>' +
      '<label class="eco-consent__chk"><input type="checkbox" ' + ok + '> <span>' + T(d ? 'consent.diario_casilla' : 'consent.perfil_casilla') +
        ' <button type="button" class="eco-consent__more" data-eco-consent-info>' + T('consent.mas_informacion') + '</button></span></label>' +
      (withAge ? '<label class="eco-consent__chk"><input type="checkbox" ' + ag + '> <span>' + T('consent.edad_casilla') + '</span></label>' +
        '<p class="eco-consent__s">' + T('consent.edad_aviso') + '</p>' : '') +
      '<p class="eco-consent__s">' + T(d ? 'consent.diario_retirada' : 'consent.perfil_retirada') +
        (opts.withNoSave ? ' ' + T('quiz.sin_email_tambien_puedes_guardar_el_pe') : '') + '</p>' +
    '</div>';
  }
  /* las casillas marcadas (la de edad no está si ya se declaró en el otro permiso) */
  function checked(box, opts) {
    opts = opts || {};
    var ok = box.querySelector('[' + (opts.okAttr || 'data-eco-consent-ok') + ']'), ag = box.querySelector('[' + (opts.ageAttr || 'data-eco-consent-age14') + ']');
    return !!(ok && ok.checked && (ag ? ag.checked : true));
  }

  var CSS = '.eco-consent{margin:14px 0;padding:14px 16px;border:1px solid rgba(var(--colors-line-and-border),1);border-radius:10px;text-align:left;font-size:13.5px;line-height:1.5}' +
    '.eco-consent p{margin:0 0 8px}.eco-consent__chk{display:flex;gap:8px;align-items:flex-start;margin:8px 0;cursor:pointer}.eco-consent__chk input{margin-top:3px;flex:none}' +
    '.eco-consent__s{font-size:12px;opacity:.78}.eco-consent__more{background:none;border:0;padding:0;font:inherit;text-decoration:underline;cursor:pointer;color:inherit}' +
    '.eco-cmodal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.45)}' +
    '.eco-cmodal__box{background:rgb(var(--colors-background));color:rgb(var(--colors-text));max-width:560px;width:100%;max-height:90vh;overflow:auto;border-radius:12px;padding:20px}' +
    '.eco-cmodal__box .eco-consent{border:0;padding:0;margin:0}.eco-cmodal__acts{display:flex;flex-wrap:wrap;gap:10px;margin-top:14px}' +
    '.eco-cmodal__info p{margin:0 0 8px;font-size:13.5px;line-height:1.5}';
  function styles() { if (document.getElementById('eco-consent-css')) return; var s = document.createElement('style'); s.id = 'eco-consent-css'; s.textContent = CSS; document.head.appendChild(s); }
  var BTN = 'button eco-btn leading-normal text-center pl-6 pr-6 pt-2 pb-2';
  function modal(inner, label) {
    styles();
    var last = document.activeElement, m = document.createElement('div');
    m.className = 'eco-cmodal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); if (label) m.setAttribute('aria-label', label);
    m.innerHTML = '<div class="eco-cmodal__box">' + inner + '</div>';
    document.body.appendChild(m);
    var prev = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
    return { el: m, close: function () { if (m.parentNode) m.parentNode.removeChild(m); document.documentElement.style.overflow = prev; try { if (last && last.focus) last.focus(); } catch (e) {} } };
  }
  function info() {
    var k = ['responsable', 'finalidad', 'base', 'destinatarios', 'conservacion', 'derechos', 'mas'];
    var md = modal('<div class="eco-cmodal__info"><p><strong>' + T('consent.capa_titulo') + '</strong></p>' +
      k.map(function (x) { return '<p>' + T('consent.capa_' + x) + '</p>'; }).join('') +
      '<div class="eco-cmodal__acts"><button type="button" class="' + BTN + ' button-outline" data-eco-cclose>' + T('consulta.cerrar') + '</button></div></div>', T('consent.capa_titulo'));
    function close() { document.removeEventListener('keydown', key, true); md.close(); }
    function key(e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } }
    md.el.addEventListener('click', function (e) { if (e.target === md.el || e.target.closest('[data-eco-cclose]')) close(); });
    document.addEventListener('keydown', key, true);
    try { md.el.querySelector('[data-eco-cclose]').focus(); } catch (e) {}
  }
  var pending = {};
  function ask(f) {
    if (!DATA[f]) return Promise.reject(new Error('eco-consent:finalidad'));
    if (has(f)) return Promise.resolve(true);
    if (pending[f]) return pending[f];
    pending[f] = new Promise(function (resolve, reject) {
      var d = f === 'diario', html = block(f, { withNoSave: !d });
      var ageShown = html.indexOf('data-age-known') < 0;
      var md = modal(html + '<div class="eco-cmodal__acts">' +
        '<button type="button" class="' + BTN + ' button-solid" data-eco-cyes disabled aria-disabled="true">' + T(d ? 'consent.diario_empezar' : 'quiz.guardar_mi_perfil') + '</button>' +
        '<button type="button" class="' + BTN + ' button-outline" data-eco-cno>' + T(d ? 'consent.ahora_no' : 'consent.ver_sin_guardar') + '</button></div>',
        T(d ? 'consent.diario_titulo' : 'consent.perfil_titulo'));
      var yes = md.el.querySelector('[data-eco-cyes]');
      function done(ok) { document.removeEventListener('keydown', key, true); md.close(); delete pending[f]; if (ok) resolve(true); else reject(new Error('eco-consent:declined')); }
      function key(e) { if (e.key === 'Escape' && !document.querySelector('.eco-cmodal__info')) { e.stopPropagation(); done(false); } }
      md.el.addEventListener('change', function () { var on = checked(md.el); yes.disabled = !on; yes.setAttribute('aria-disabled', on ? 'false' : 'true'); });
      md.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-eco-cno]')) { done(false); return; }
        if (e.target.closest('[data-eco-cyes]')) { if (!checked(md.el)) return; grant(f, { edad14: true, ageShown: ageShown }); done(true); }
      });
      document.addEventListener('keydown', key, true);
      try { md.el.querySelector('input').focus(); } catch (e) {}
    });
    return pending[f];
  }

  /* «Más información» en cualquier sitio (bloques, aviso de privacidad de Mi cuenta) abre la capa 4.3 */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-eco-consent-info]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); info();
  });

  purge();
  document.addEventListener('eco:store-ready', purge); // backend remoto: los datos llegan después

  window.EcoConsent = {
    VERSION: VERSION,
    has: has, ask: ask, grant: grant, revoke: revoke,
    block: block, checked: checked, info: info, age14: age14,
    keys: function (f) { return (DATA[f] || []).slice(); }
  };
})();
